export const ROOT = "/";
export const ACCOUNT_INFORMATION = "/account/information";
export const ACCOUNT_CHANGE_PASSWORD = "/account/change-password";
export const ACCOUNT_LOCATIONS = "/account/locations";
export const ACCOUNT_REQUEST_USER = "/account/request-user";
export const ORDERING = "/ordering";
export const ORDERING_NEW_SINGLE_ORDER = "/ordering/new";
export const ORDERING_NEW_BULK_ORDER = "/ordering/new-bulk-order";
export const ORDERING_REQUEST_QUOTE = "/ordering/request-quote";
export const ORDERING_VIEW = "/ordering/view";
export const INVOICING = "/invoicing";
export const REPORTING_TRANSACTIONS = "/reporting/transactions";
export const REPORTING_TRANSACTIONS_HISTORY = "/reporting/transactions-history";
export const REPORTING_RETURNS = "/reporting/returns";
export const RESOURCES_FEEDBACK = "/resources/feedback";
export const RESOURCES_CUSTOMER_SERVICE = "/resources/customer-service";
export const RESOURCES_FAQ = "/resources/faq";
export const NEW_CUSTOMER_SETUP = "/new-customer-setup";
export const COLLECTION_ORDERS = "/collection-orders";
export const COLLECTION_ORDERS_NEW = "/collection-orders/new";
export const COP_DASHBOARD = "/cop-dashboard";
export const LOGS_ORDER = "/logs/order";
export const REQUEST_ACCOUNT = "/request_account";
export const LOGOUT = "/logout";
export const SWITCH_ACCOUNT = "/switch-account";
export const ALL_USERS = "/all-users";
export const MANAGE_RECIPIENTS = "/manage-subscriptions";
